 
<template>
 <div id="app">  
  <transition :name="transitionName"> 
    <keep-alive> 
      <router-view v-if="$route.meta.keepAlive" class="Router"> 
        <slot name="header"></slot>
        <slot></slot>
        <slot name="nav"></slot>   
      </router-view> 
    </keep-alive>
  </transition>
  <transition :name="transitionName"> 
    <router-view v-if="!$route.meta.keepAlive" class="Router"> 
      <slot name="header"></slot>
			  <slot></slot>
			<slot name="nav"></slot> 
    </router-view>
   </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { navigatorGetCurrentPosition } from "@/util";

export default {
  mounted() {  
     
  },
 data() {
   return{
     transitionName:'' 
   } 
  },
  computed: {
    ...mapState(["fromUser","toUser"])
  }, 
  watch: {//使用watch 监听$router的变化
    $route(to, from){
         //如果to索引大于from索引,判断为前进状态,反之则为后退状态
       if(to.meta.index > from.meta.index){
         //设置动画名称
         this.transitionName = 'turn-on';
       }else if(to.meta.index <from.meta.index){
         this.transitionName = 'turn-off';
       }else{
         this.transitionName='';
       }
 
    }
  },
  methods: {
     ...mapActions([
      
    ]),
    getCurrentPosition() {
      const vm = this;
      function getPosition() {
        navigatorGetCurrentPosition(vm.reportPosition)
      }
      // 定时获取位置 30s
      setInterval(getPosition, 30*1000);
    },
    // 上报位置
    reportPosition(point) {
      axios
        .get("/psuser/psuser!loc.action", {
          params: {
            _id: this.userInfo.id,
            lat: point.lat,
            lng: point.lng
          }
        })
        .then(() => {})
        .catch(function(error) {
          window.console.log(error);
        });
    },
    checkUpdate() {
      const params = window.location.search
        .substr(1)
        .split("&")
        .reduce((r, p) => {
          const ky = p.split("=");
          r[ky[0]] = ky[1];
          return r;
        }, {});
      if (params.app === "1") {
        axios
          .get("/psuser/psuser!getbb.action", {
            params: {
              bb: params.bb
            }
          })
          .then(response => {
            if (response.data.state === 1) {
              if (confirm("发现新版本，确认更新吗？")) {
                android.openBrower(response.data.url);
              }
            }
          })
          .catch(function(error) {
            window.console.log(error);
          });
      }
    },
    isWeiXin(){ 
      var ua = window.navigator.userAgent.toLowerCase(); 
      if(ua.match(/MicroMessenger/i) == 'micromessenger'){
      return true;
      }else{
      return false;
      }
    }, 

   },

};
</script>


<style lang="scss">
 *,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html {
  font-size: 100%;
  height: 100%;
  overflow: hidden;
}
body {
  height: 100%;
  background: #f3f3f3;
  overflow: hidden;
}
ul {
  list-style: none;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  color: #2c3e50;
  height: 100%;
  overflow:auto;
  position: relative;
}
.ui_border_t:before {
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  left: 0;
  height: 1px;
  content: "";
  transform-origin: top;
  -webkit-transform-origin: top;
  -webkit-transform: scaleY(0.4);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: scaleY(0.4);
  background-color: #c8c7cc;
  z-index: 1;
}
.ui_border_b:after {
  position: absolute;
  display: block;
  bottom: 0;
  right: 0;
  left: 0;
  height: 1px;
  content: "";
  transform-origin: bottom;
  -webkit-transform-origin: bottom;
  -webkit-transform: scaleY(0.4);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: scaleY(0.4);
  background-color: #c8c7cc;
  z-index: 1;
}
.ui_border_l:before {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 1px;
  height: 100%;
  content: "";
  transform-origin: left;
  -webkit-transform-origin: left;
  -webkit-transform: scaleX(0.4);
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: scaleX(0.4);
  background-color: #c8c7cc;
  z-index: 1;
}
.container {
  height: 100%;
  padding-bottom: 3.5rem;
  overflow: auto;
  .content {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  &.header {
    padding-top: 3rem;
  }
  &.full {
    padding-bottom: 0;
  }
  &.white {
    background: #fff;
  }
}
.has-fix-bar {
  padding-bottom: 3rem;
}
::-webkit-scrollbar {
  display: none;
}
@media screen and (min-width: 640px) {
  .ui_border_t:before,
  .ui_border_l:before,
  .ui_border_b:before {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
  }
}
</style>
